import { SignnowSignedStatus } from '~/utils/store';
import { trackEvent, TRACK } from '~/utils/tracking';
import { UnparsedQueryParams } from '../../types';

// We are going to send the event query params to signnow
// and track the event when the user returns from signnow
const signnowEventQueryParams = ['esignSa_signed', 'esignPg_signed', 'esignMdu_signed', 'declined'];

export const handleSignnow = ({ params: { event } }: { params: UnparsedQueryParams }) => {
  if (!event || !signnowEventQueryParams.includes(event)) return;
  if (event === 'declined') {
    localStorage.setItem('signnow_declined', 'true');
    return { signedStatus: 'declined' as SignnowSignedStatus };
  }
  const [contract, eventName] = event.split('_');
  trackEvent(TRACK.returnedFromSignnow, { signnowEvent: event });
  localStorage.setItem(contract, eventName);
  return { signedStatus: event as SignnowSignedStatus, [contract]: eventName };
};
